import React from "react";
import PropTypes from "prop-types";

import DateTime from "components/library/DateTime";

export default function DatePicker(props) {
  return (
    <DateTime
      dateFormat="MMMM DD, YYYY"
      timeFormat={false}
      placeholder="Select a date"
      {...props}
    />
  );
}

DatePicker.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};
